import { NgClass } from '@angular/common';
import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    Output,
    ViewChild,
} from '@angular/core';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import {
    MapPolyline,
    RideTypeService,
} from '@polaris-customerweb/sharedcomponents.shared';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { AnalyticsDataDirective } from 'src/app/directives/analytics-data.directive';
import { AnalyticsDirective } from 'src/app/directives/analytics.directive';
import { MapPoint } from 'src/app/models/map-point';

@Component({
    imports: [
        AnalyticsDataDirective,
        AnalyticsDirective,
        AngularSvgIconModule,
        NgClass,
    ],
    selector: 'rdx-plan-ride-button',
    styleUrls: ['./plan-ride-button.component.scss'],
    templateUrl: './plan-ride-button.component.html',
})
export class PlanRideButtonComponent {
    @Input() entityType: string;
    @Input() mapPoint: MapPoint;
    @Input() mapPolyline: MapPolyline;
    @Input() showPlanRideIcon = false;

    @Output() startRidePlanningClicked = new EventEmitter<string>();

    @ViewChild('rideTypeSelector') rideTypeSelector: ElementRef<HTMLDivElement>;

    isRideTypeSelectorShowing = false;

    constructor(
        private configService: ConfigService,
        private rideTypeService: RideTypeService
    ) {}

    @HostListener('document:click', ['$event'])
    closePlanARide(event: MouseEvent): void {
        if (
            !this.rideTypeSelector.nativeElement.contains(event.target as Node)
        ) {
            this.isRideTypeSelectorShowing = false;
        }
    }

    goToOrvRidePlanning(): void {
        this.rideTypeService.setRideType('ORV');
        this.planRideToHere('ORV');
    }

    goToSnowRidePlanning(): void {
        this.rideTypeService.setRideType('SNO');
        this.planRideToHere('SNO');
    }

    openPlanARide(event: MouseEvent): void {
        event.stopPropagation();
        if (this.configService.isOffRoad) {
            this.isRideTypeSelectorShowing = !this.isRideTypeSelectorShowing;
        } else {
            this.planRideToHere(undefined);
        }
    }

    planRideToHere(rideType: 'SNO' | 'ORV' | undefined): void {
        this.startRidePlanningClicked.emit(rideType);
    }
}
